import { memo } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const ScrollToTop = memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
});

ScrollToTop.displayName = "ScrollToTop";

export default ScrollToTop;
